import { render, staticRenderFns } from "./AwardForm.vue?vue&type=template&id=331fd5ad"
import script from "./AwardForm.vue?vue&type=script&lang=js"
export * from "./AwardForm.vue?vue&type=script&lang=js"
import style0 from "./AwardForm.vue?vue&type=style&index=0&id=331fd5ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports